import { z } from 'zod';
/**
 * Phase 17 — verified account-email change.
 *
 * The signed-in user requests a new email; a confirm link is sent TO the new
 * address and a security alert TO the old address. The account email is NOT
 * updated until the confirm link is used (verify-first). Confirming revokes
 * every existing session and issues a fresh one on the new address.
 */
/** POST /api/v1/auth/email-change/request body. */
export const EmailChangeRequestSchema = z.object({
    newEmail: z.string().email().max(254).toLowerCase(),
});
/** Response after a change request is accepted. Always the same shape
 *  regardless of whether the target address was already taken (no account
 *  enumeration — the target owner would only ever learn via their own inbox). */
export const EmailChangeRequestResponseSchema = z.object({
    status: z.literal('sent'),
});
/** POST /api/v1/auth/email-change/confirm body.
 *  Token shape mirrors the magic-link token (base64url 32-byte). */
export const EmailChangeConfirmRequestSchema = z.object({
    token: z.string().min(32).max(256),
});
//# sourceMappingURL=email-change.schema.js.map